export type TagsEditorFormState = {
  initialView?: boolean;
  editMode?: boolean;
  helpTagType?: unknown | null;
  attributesModalProps?: unknown;
  tagValueModalProps?: unknown;
  newTagCreationModalProps?: unknown;
  inputTarget?: unknown;
};

export type TagsEditorFormAction =
  | { type: "startEditing" }
  | { type: "finishEditing"; inputTarget?: unknown }
  | { type: "showTagTypeHelp"; tagType: unknown }
  | {
      type: "toggleAttributesModal";
      props: unknown;
      finishEditing?: boolean;
    }
  | { type: "toggleTagValueModal"; props: unknown }
  | { type: "toggleNewTagCreationModal"; props: unknown }
  | { type: "hideHelp" };

export const formStateReducer = (
  state: TagsEditorFormState,
  action: TagsEditorFormAction
): TagsEditorFormState => {
  switch (action.type) {
    case "startEditing":
      return { ...state, initialView: false, editMode: true };
    case "finishEditing":
      if (
        state.helpTagType ||
        state.attributesModalProps ||
        state.tagValueModalProps ||
        state.newTagCreationModalProps
      ) {
        return { ...state, inputTarget: action.inputTarget ?? null };
      }
      return { editMode: false };
    case "showTagTypeHelp":
      return { ...state, helpTagType: action.tagType };
    case "toggleAttributesModal":
      return {
        ...state,
        attributesModalProps: action.props,
        editMode: action.finishEditing ? false : (state.editMode ?? false),
      };
    case "toggleTagValueModal": {
      return {
        ...state,
        tagValueModalProps: action.props,
      };
    }
    case "toggleNewTagCreationModal":
      return {
        ...state,
        newTagCreationModalProps: action.props,
      };
    case "hideHelp":
      return { ...state, helpTagType: null, inputTarget: null };
    default: {
      const _exhaustive: never = action;
      throw new Error("Unsupported action", _exhaustive);
    }
  }
};
